import { useState } from 'react';
import { createPortal } from 'react-dom';

// La locandina a tutto schermo, con i due gesti che servono a chi organizza:
// condividerla (Instagram, gruppi WhatsApp) e salvarla sul telefono.
// Sull'iPhone "Salva" apre il foglio di condivisione, dove c'e' "Salva
// immagine": e' il modo nativo, un download diretto in Foto non esiste.
// "Condividi" manda solo la foto, senza testo: WhatsApp la tratta come una
// foto vera, intera. Con un testo insieme la gestisce in altro modo e una
// locandina 9:16 esce tagliata sopra e sotto. Il messaggio lo scrive
// l'organizzatore, a mano (passo 1 del percorso d'invito).
function PosterViewer({ url, titolo, onClose }) {
  const [stato, setStato] = useState('');
  const nomeFile = `${(titolo || 'locandina').replace(/[^\p{L}\p{N}]+/gu, '-').toLowerCase()}.jpg`;

  const comeFile = async () => {
    const r = await fetch(url);
    const blob = await r.blob();
    return new File([blob], nomeFile, { type: blob.type || 'image/jpeg' });
  };

  const condividi = async () => {
    setStato('');
    try {
      const file = await comeFile();
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file] });
      } else {
        setStato('Da qui non si puo\' condividere: usa "Salva" e mandala dalla galleria');
      }
    } catch (e) {
      if (e?.name !== 'AbortError') { console.error(e); setStato('Non sono riuscito a condividerla'); }
    }
  };

  const salva = async () => {
    setStato('');
    try {
      const file = await comeFile();
      if (navigator.canShare && navigator.canShare({ files: [file] }) && /iPhone|iPad|Android/i.test(navigator.userAgent)) {
        await navigator.share({ files: [file] });
        return;
      }
      const a = document.createElement('a');
      a.href = URL.createObjectURL(file);
      a.download = nomeFile;
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
    } catch (e) {
      if (e?.name !== 'AbortError') { console.error(e); setStato('Non sono riuscito a salvarla'); }
    }
  };

  const bottone = {
    flex: 1, minHeight: 48, padding: '12px 16px', borderRadius: 12, cursor: 'pointer',
    fontSize: 18, fontWeight: 800, fontFamily: 'inherit',
  };

  // Montato direttamente nel body: la vista della serata ha un'animazione
  // d'ingresso con transform, e dentro un elemento con transform un
  // position:fixed si aggancia a quell'elemento invece che allo schermo. Il
  // visore si apriva dall'inizio della pagina, non da dove si stava guardando.
  return createPortal(
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 400, background: 'rgba(0,0,0,0.94)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: 'max(env(safe-area-inset-top),16px) 16px max(env(safe-area-inset-bottom),16px)',
        boxSizing: 'border-box' }}>
      <button onClick={onClose} aria-label="Chiudi"
        style={{ position: 'absolute', top: 'max(env(safe-area-inset-top),16px)', right: 16,
          width: 44, height: 44, borderRadius: 999, border: '1px solid rgba(255,255,255,0.2)',
          background: 'rgba(255,255,255,0.08)', color: '#fff', fontSize: 24, cursor: 'pointer' }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>
      </button>

      <img src={url} alt={titolo ? `Locandina: ${titolo}` : 'Locandina'} onClick={e => e.stopPropagation()}
        style={{ maxWidth: '100%', maxHeight: 'calc(100% - 120px)', objectFit: 'contain', borderRadius: 8 }}/>

      <div onClick={e => e.stopPropagation()}
        style={{ display: 'flex', gap: 10, width: '100%', maxWidth: 420, marginTop: 18 }}>
        <button onClick={condividi}
          style={{ ...bottone, border: 'none', background: '#ED4D1D', color: '#fff' }}>
          Condividi
        </button>
        <button onClick={salva}
          style={{ ...bottone, border: '1px solid rgba(255,255,255,0.25)', background: 'rgba(255,255,255,0.08)', color: '#fff' }}>
          Salva
        </button>
      </div>
      {stato && <div style={{ marginTop: 10, fontSize: 16, color: '#B5AA9A' }}>{stato}</div>}
    </div>,
    document.body
  );
}

export default PosterViewer;
